/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Destination_LocalInputs */



/**
* | output |
* | --- |
* | "Local Storage" |
*
* @param {Options_Backup_Destination_LocalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_destination_local = /** @type {((inputs?: Options_Backup_Destination_LocalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Destination_LocalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Stockage local")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lokaler Speicher")
	if (locale === "it") return /** @type {LocalizedString} */ ("Archiviazione locale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Локальное хранилище")
	if (locale === "es") return /** @type {LocalizedString} */ ("Almacenamiento local")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("本地存储")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ローカルストレージ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्थानीय भंडारण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Armazenamento local")
	return /** @type {LocalizedString} */ ("Local Storage")
});